import { useState, useEffect } from 'react';
import { tcgApi } from '../api/client';

export function useTcgSets() {
  const [sets, setSets] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    tcgApi.listSets()
      .then((res) => {
        if (!cancelled) {
          setSets(res.data.items || []);
        }
      })
      .catch(() => {
        // silently fail — sets dropdown just won't populate
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, []);

  return { sets, loading };
}
